<h3 class="text-primary border-b border-gray pb-1">{{title}}</h3>

<ng-container>
  <mat-list *ngIf="logs.length > 0; else noActivityTemplate">
    @let visibleLogs = show ? logs : [logs[0]];
    <mat-list-item *ngFor="let log of visibleLogs">
      <span matListItemTitle>{{mapping[log.action] ?? log.action}}</span>
      <span matListItemLine>
        <eas-user-title username="{{ log.masquerade || log.actor }}"></eas-user-title>
        <span *ngIf="log.masquerade">
          &nbsp;<ng-container i18n>as</ng-container>&nbsp;<eas-user-title username="{{ log.actor }}"></eas-user-title>
        </span>
        &nbsp;<ng-container i18n>on</ng-container>&nbsp;<span mat-line>{{ log.date | date:'medium' }}</span>
      </span>
      <span matListItemLine *ngIf="log.source">
        <ng-container i18n>source: </ng-container> {{ log.source }}
      </span>
    </mat-list-item>
  </mat-list>
  <ng-template #noActivityTemplate>
    <p i18n>There has been no activity...</p>
  </ng-template>
</ng-container>

<button
  *ngIf="logs.length > 1"
  mat-stroked-button
  color="accent"
  type="button"
  (click)="show = !show">
  {{ getButtonAction() }}
</button>
